import React from 'react'

import defaultTo from 'lodash/defaultTo'

import { ITableData } from 'components/layout/table/tableData'
import Input from 'components/ui/input'

export interface IItem {
  value: string | number
  unit?: string
  hideUnit?: boolean
  rightAlign?: boolean
}

interface IRapidEditableTableData extends ITableData {
  item: IItem
  placeholder?: string
  unit?: string
  onChange?: (key: string, item: IItem) => void
}

const RapidEditableTableData: React.FC<IRapidEditableTableData> = props => {
  const { name, unit, col, item, leftAlign, placeholder, onChange } = props

  const hasUnit = () => (props.unit ? true : false)

  const handleChange = (key: string, item: IItem) => {
    if (onChange) onChange(key, item)
  }

  const isActive = () => item.value !== ''

  return (
    <div key={name} className={`flex w-${col}/12 items-end pl-30 first-child:pl-0`}>
      <div className={`flex w-full`}>
        <Input
          type={hasUnit() ? 'number' : 'text'}
          unit={hasUnit() ? unit : undefined}
          value={hasUnit() ? Number(item.value) : String(item.value)}
          name={name}
          onChange={value => {
            handleChange(
              name,
              Object.assign(
                { value: hasUnit() && value ? Number(value) : value },
                hasUnit() ? { unit: item.unit } : null,
              ),
            )
          }}
          hideUnit={defaultTo(item.hideUnit, false)}
          rightAlign={defaultTo(item.rightAlign, false)}
          placeholder={placeholder}
          underline
          leftAlign={leftAlign}
        />
      </div>
      {hasUnit() && !defaultTo(item.hideUnit, false) && (
        <div
          className={`flex ${
            leftAlign ? 'text-left' : 'text-right'
          } items-center first-child:text-left`}
        >
          <div
            key={name}
            className={`h-full w-full relative pl-3 py-10 border-b-1 ${
              isActive() ? 'border-black' : 'border-gray-200'
            }`}
          >
            <div className="h-full flex items-center">
              <p
                className={`w-full text-black ${
                  isActive() ? '' : 'text-gray-200 opacity-50 '
                }text-13 font-400 tracking-0.1`}
              >
                {item.unit}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default RapidEditableTableData
